import { render, staticRenderFns } from "./CzPage.vue?vue&type=template&id=085d8de4&scoped=true&"
import script from "./CzPage.vue?vue&type=script&lang=js&"
export * from "./CzPage.vue?vue&type=script&lang=js&"
import style0 from "./CzPage.vue?vue&type=style&index=0&id=085d8de4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085d8de4",
  null
  
)

export default component.exports